module.exports = __webpack_public_path__ + "static/media/02_001.12212faf.jpg";